import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { PlayIcon } from '@heroicons/react/24/solid';

const StartNode: React.FC<NodeProps> = ({ data, selected }) => {
  return (
    <div
      className={`px-1 py-0.5 shadow-sm rounded bg-white border ${
        selected ? 'border-primary-500' : 'border-green-500'
      }`}
    >
      <div className="flex items-center">
        <div className="rounded-full w-4 h-4 flex items-center justify-center bg-green-100">
          <PlayIcon className="w-3 h-3 text-green-600" />
        </div>
        <div className="ml-1">
          <div className="text-[10px] font-semibold text-gray-700">{data.label}</div>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-green-500 border-2 border-white hover:w-4 hover:h-4 transition-all cursor-crosshair"
        style={{ right: '-6px' }}
      />
    </div>
  );
};

export default StartNode;